exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-nav{background:#e9ecef;padding:15px 0;color:#06c}.subtitulo{min-height:57px;position:relative;display:flex;align-items:center}.col-md-12{padding-right:15px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ebd8b3f0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/Inicio/Plataforma.vue
// module id = 1111
// module chunks = 0